<div class="modal fade modal-full-width " aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content"  *ngIf="isOpen">
            <div class="modal-header">
                <h4 class="modal-title" *ngIf="editMode">
                    Atualizar Projeções do Cliente
                </h4>
                <h4 class="modal-title" *ngIf="!editMode">
                    Adicionar Projeções do Cliente
                </h4>                
            </div>
            <div class="modal-body">
                <sgt-cliente-analise-mercado-projecao-form
                    #form
                    [embedded]="true"
                    [idCliente]="idCliente"
                    [mes]="mes"
                    [ano]="ano">
                </sgt-cliente-analise-mercado-projecao-form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="cancel()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-success" (click)="save()" id="btnSaveClienteAnaliseMercadoProjecaoFormModal">
                    Salvar
                </button>                
            </div>
        </div>
    </div>
</div>
